var exports = {
  "tB": "ContextMenu.module__backdrop___RFhyMi",
  "D8": "ContextMenu.module__contextMenuPositioner___RFhyMi",
  "He": "ContextMenu.module__contextMenu___RFhyMi",
  "KY": "ContextMenu.module__menuScroller___RFhyMi",
  "NC": "ContextMenu.module__menuScrollerContent___RFhyMi",
  "AS": "ContextMenu.module__item___RFhyMi",
  "r9": "ContextMenu.module__disabled___RFhyMi",
  "OR": "ContextMenu.module__danger___RFhyMi",
  "Fx": "ContextMenu.module__itemIcon___RFhyMi",
  "IR": "ContextMenu.module__itemLabel___RFhyMi",
  "Ah": "ContextMenu.module__itemWithShortcut___RFhyMi",
  "g$": "ContextMenu.module__itemShortcut___RFhyMi",
  "ED": "ContextMenu.module__itemShortcutHidden___RFhyMi",
  "dP": "ContextMenu.module__itemLabelContainer___RFhyMi",
  "b": "ContextMenu.module__itemLabelText___RFhyMi",
  "Lo": "ContextMenu.module__itemHint___RFhyMi",
  "fV": "ContextMenu.module__submenuCaret___RFhyMi",
  "me": "ContextMenu.module__separator___RFhyMi",
  "Os": "ContextMenu.module__group___RFhyMi",
  "_0": "ContextMenu.module__selectableSection___RFhyMi",
  "dl": "ContextMenu.module__checkboxItem___RFhyMi",
  "fb": "ContextMenu.module__checkboxIndicator___RFhyMi",
  "kv": "ContextMenu.module__checkbox___RFhyMi",
  "xY": "ContextMenu.module__checkboxChecked___RFhyMi",
  "AM": "ContextMenu.module__groupLabel___RFhyMi",
  "HG": "ContextMenu.module__submenuPopover___RFhyMi",
  "a": "ContextMenu.module__submenuScroller___RFhyMi",
  "pT": "ContextMenu.module__quickReactionsGroup___RFhyMi",
  "gV": "ContextMenu.module__quickReactionItem___RFhyMi",
  "z5": "ContextMenu.module__quickReactionShortcut___RFhyMi",
  "dd": "ContextMenu.module__quickReactionTooltipContent___RFhyMi",
  "Vx": "ContextMenu.module__quickReactionTooltipHint___RFhyMi",
  "hH": "ContextMenu.module__emojiSubmenuIcon___RFhyMi",
  "XN": "ContextMenu.module__emojiSubmenuImg___RFhyMi",
};

module.exports = exports;
